import React from 'react';
import { withRouter } from 'react-router-dom';
import FormContainer from '../../containers/Form';
import { BaseForm } from '../../base';
import ItemPendencias from '../../components/ItemPendencias';

class Pendencias extends BaseForm {
  render() {
    const { breadCrumb } = this.props;
    return (
      <FormContainer
        title={`Checagem do conteúdo do ${breadCrumb}`}
        previous="fonte"
        next="confirmar"
      >
        <ItemPendencias breadCrumb={breadCrumb} />
      </FormContainer>
    );
  }
}


export default withRouter(Pendencias);
